module.exports = __webpack_public_path__ + "static/media/calendarIcon.82c14f46.svg";